const password = /^(?=.*[a-zA-Z0-9])(?!.*\s).{6,}$/;
const email = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const link = /^((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)$/;
const fbLink = /(?:https?:\/\/)?(?:www\.)?(?:fb\.com|facebook\.com)\S*/i;
export { password, email, link, fbLink };
